<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid}"
  >
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.firstName"
          :value="data.name"
          :label="$t('forms.labels.firstName')"
          :disabled="!canEditMember"
          outlined
          :rules="{ required: true, min: 1, max: 200 }"
          data-cy="memberInformation-firstName"
          @change="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.lastName"
          :value="data.lastName"
          :label="$t('forms.labels.lastName')"
          :disabled="!canEditMember"
          outlined
          :rules="{ required: true, min: 1, max: 200 }"
          data-cy="memberInformation-lastName"
          @change="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <PhoneNumberInput
          :refObserver="$refs.observer"
          :value="data.phoneNumber.number"
          :disabled="!canEditMember"
          :isPhoneNumberValid="data.isPhoneNumberValid"
          cyData="memberInformation-phone"
          @inputChanged="phoneInput"
          @change="updateData"
        />
      </v-col>
      <v-col cols="12">
        <VTextField
          v-model="data.email"
          :value="data.email"
          :label="$t('forms.labels.email')"
          :disabled="!canEditMember"
          outlined
          :rules="{ required: true, min: 1, max: 200, email: true }"
          data-cy="memberInformation-email"

          @change="updateData"
        />
      </v-col>
      <v-col
        v-if="roles && fromSection === 'administration'"
        cols="12"
      >
        <VAutocomplete
          v-model="selectedRoles"
          :label="$t('forms.labels.roles')"
          :items="roles"
          :required="true"
          :disabled="!canEditMember"
          outlined
          itemText="label"
          itemValue="value"
          @change="updateData"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { mapGetters, mapActions } from 'vuex';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import PhoneNumberInput from '@/components/shared/widgets/forms/PhoneNumberInput.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import allRoles from '@/constants/roles';


export default {
    components: {
        SlotScopeWatcher,
        VAutocomplete,
        VTextField,
        ValidationObserver,
        PhoneNumberInput,
    },
    props: {
        roles: {
            type: Array,
            default: () => [],
        },
        member: {
            type: Object,
            default: () => ({ empty: true }),
        },
        fromSection: {
            type: String,
            default: '',
        },
        dirty: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                name: null,
                lastName: null,
                email: null,
                phoneNumber: { number: '' },
                roles: [],
                isPhoneNumberValid: true,
            },

        };
    },

    computed: {
        ...mapGetters([
            'hasPermission',
            'hasRole',
        ]),
        canLabEdit() {
            const labListRoles = [
                allRoles.LABORATORY_MANAGER.value,
                allRoles.LABORATORY_MICROBIOLOGIST.value,
                allRoles.LABORATORY_CHEMIST.value,
                allRoles.LABORATORY_TECHNICIAN.value,
            ];
            return this.hasRole('laboratoryManager') && labListRoles.includes(this.data.roles[0].key || this.data.roles[0]);
        },
        selectedRoles: {
            get() {
                const currentRole = this.data.roles[0];
                return currentRole.key || currentRole || null;
            },
            set(val) {
                const newRole = this.roles.find(role => role.value === val);
                this.data.roles = [newRole.value];
            },
        },

        isEdition() {
            return !this.member.empty;
        },

        canEditMember() {
            return (this.hasPermission('members.edit') && this.fromSection === 'administration')
              || (this.hasPermission('clients.members.edit') && this.fromSection === 'clientTeam')
              || (this.hasPermission('members.roles.edit') && this.canLabEdit);
        },
    },
    watch: {
        member: {
            handler() {
                if (this.isEdition) {
                    this.data = this.member;
                    if (this.member.phoneNumber) {
                        this.data.phoneNumber = typeof (this.member.phoneNumber) === 'object' ? this.member.phoneNumber : { number: this.member.phoneNumber };
                    } else {
                        this.data.phoneNumber = { number: '' };
                    }
                }
            },
            immediate: true,
        },
        data: {
            handler() {
                this.$emit('sendData', this.data);
            },
            deep: true,
        },
    },
    mounted() {
        this.$emit('sendData', this.data);
    },
    methods: {
        ...mapActions({
            disablePreventQuitFormular: 'disablePreventQuitFormular',
            activePreventQuitFormular: 'activePreventQuitFormular',
        }),
        phoneInput(number, payload) {
            this.data.phoneNumber = !number ? {} : payload;
            this.data.isPhoneNumberValid = payload.valid;
            this.updateData();
        },
        updateData() {
            this.$emit('sendDatas', this.data);
            if (this.dirty) this.activePreventQuitFormular();
        },
    },
};
</script>
